import { useMemo } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";

export const BlogBody = ({ html, markdown }) => {
  const content = useMemo(() => {
    // Marked accepts both actual Markdown and legacy HTML stored in body_md.
    const parsed = html || marked.parse(markdown || "", { gfm: true, async: false });
    const fragment = DOMPurify.sanitize(parsed, {
      RETURN_DOM_FRAGMENT: true,
      ADD_ATTR: ["target"],
      FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input", "button", "style", "link", "meta", "svg", "math"],
      FORBID_ATTR: ["style"],
    });
    fragment.querySelectorAll("a").forEach((link, index) => {
      link.setAttribute("data-testid", link.getAttribute("data-testid") || `blog-body-link-${index + 1}`);
      if (link.getAttribute("target") === "_blank") link.setAttribute("rel", "noopener noreferrer");
    });
    const container = document.createElement("div");
    container.appendChild(fragment);
    return container.innerHTML;
  }, [html, markdown]);
  return <div data-testid="blog-rendered-body" className="min-w-0 [overflow-wrap:anywhere] [&_a]:text-emerald-800 [&_a]:underline [&_h2]:text-lg [&_h2]:font-bold [&_h2]:mt-8 [&_h3]:font-semibold [&_h3]:mt-6 [&_p]:my-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:my-2" dangerouslySetInnerHTML={{ __html: content }}/>;
};